/* eslint-disable */
import { toCamelCase, toSnakeCase } from '@/utils/string'

// スネークケースからキャメルケースに変換（オブジェクト）.
export const toCamelCaseObject = (obj) => {
  const result = {}
  Object.keys(obj).forEach((key) => {
    result[toCamelCase(key)] = obj[key]
  })
  return result
}

// キャメルケースからスネークケースに変換（オブジェクト）.
export const toSnakeCaseObject = (obj) => {
  const result = {}
  Object.keys(obj).forEach((key) => {
    result[toSnakeCase(key)] = obj[key]
  })
  return result
}
/* eslint-disable */
